import React from 'react'

import { Col, Table } from 'antd';

function Roles( {roleTitle, roleIndex, roleKey, data} ) {

    const columns = [
        {
          title:`${roleTitle}`,
          dataIndex:`${roleIndex}`,
          key:`${roleKey}`,
          render: (text) => <span className="onclick-text">{text}</span>,
        },
        {
          title: 'Users with Role',
          dataIndex: 'userswithRole',
          key: 'userswithRole',
        },
    ];
  return (
    <div className='roles'>
        <Col span={24}>
         <Table columns={columns} dataSource={data} pagination={false} />
        </Col>
    </div>
  )
}

export default Roles
